var render = function render(){var _vm=this,_c=_vm._self._c;return _c('weekly-execution',{attrs:{"is-extranet":"","report-mode":"","min-date":_vm.MIN_DATE,"highways":_vm.highways,"default-from-date":_vm.FROM_DATE,"fetch-source":{
    fetchReal: _vm.fetchReal,
    fetchExpected: _vm.fetchExpected,
  },"gantt-props":{
    sinistersURL: 'siniestros/carreteros/cliente',
  }}},[_c('span',{attrs:{"slot":"empty-content-action"},slot:"empty-content-action"})])
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/pages/CustomersExtranet/ExecutionReport.vue